export default __webpack_public_path__ + "static/media/tokenB2E2.faffe52c.png";